export default __webpack_public_path__ + "static/media/auni.8e63428a.svg";